import { en } from "./en";
import { es } from "./es";
import { zh } from "./zh";
import { vi } from "./vi";
import { th } from "./th";

export type TKey = keyof typeof en;
export type Dict = Record<TKey, string>;
export type Vars = Record<string, string | number>;
export type Translate = (key: TKey, vars?: Vars) => string;

export const LANGS = ["en", "es", "zh", "vi", "th"] as const;
export type Lang = (typeof LANGS)[number];

export const LANG_NAMES: Record<Lang, string> = {
  en: "English",
  es: "Español",
  zh: "中文",
  vi: "Tiếng Việt",
  th: "ไทย",
};

export const HTML_LANG: Record<Lang, string> = {
  en: "en",
  es: "es",
  zh: "zh-CN",
  vi: "vi",
  th: "th",
};

const DICTS: Record<Lang, Dict> = { en, es, zh, vi, th };

export function isLang(value: unknown): value is Lang {
  return typeof value === "string" && (LANGS as readonly string[]).includes(value);
}

function isKey(key: string): key is TKey {
  return Object.prototype.hasOwnProperty.call(en, key);
}

function fill(template: string, vars?: Vars): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match,
  );
}

export function makeT(lang: Lang): Translate {
  const dict = DICTS[lang];
  return (key, vars) => fill(dict[key] ?? en[key], vars);
}

export const enT = makeT("en");

export function optionLabel(t: Translate, group: "own" | "title" | "acct", value: string): string {
  const key = `${group}.${value}`;
  return isKey(key) ? t(key) : value;
}

export function selectCopy(t: Translate, label: string) {
  return {
    placeholder: t("common.select"),
    searchPlaceholder: t("common.search", { label: label.toLowerCase() }),
    emptyText: t("common.noMatches"),
  };
}
